<template>
    <div
        class="home-tile"
        :class="isAdvanced?'avanced':''"
        @click.stop="goToMotorDetails"
    >
        <div class="tile-icon-image">
            <img src="static/images/motor-image.svg">
        </div>
        <div class="tile-icon-image-bg">
            <img src="static/images/motor-image.svg">
        </div>
        <div class="title-container">
            <div class="tile-text">
                <h2>{{ motor.name }}</h2>
                <p
                    v-if="isAdvanced"
                >Audit de mon moteur (avancé)</p>
                <p
                    v-else
                >Audit de mon moteur (simple)</p>
            </div>
            <div class="action-buttons-container">
                <div
                    class="element-icon"
                    @click.stop="goToMotorDetails"
                >
                    <i class="el-icon-view icon"></i>
                </div>
                <div
                    class="element-icon"
                    @click.stop="editMotor"
                >
                    <i class="el-icon-edit icon"></i>
                </div>
                <div
                    class="element-icon"
                    :loading="deleteLoading"
                    @click.stop="deleteMotor"
                >
                    <i class="el-icon-delete icon"></i>
                </div>
            </div>
        </div>
        <div class="buttons-motor-container">
            <el-button
                @click.stop="loadMeasurements"
            >
                Charger les mesures
            </el-button>
            <div>
                <el-button
                    :disabled="disabledXlsxButton"
                    :loading="loadingXlsxButton"
                    @click.stop="downloadXlsx"
                >
                    Télécharger courbes
                </el-button>
                <el-button
                    :disabled="disabledPptxButton"
                    :loading="loadingPptxButton"
                    @click.stop="downloadPptx"
                >
                    Télécharger rapport
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {

    name: 'MotorCard',

    props:{
        motor:{
            type: Object,
            required: true,
        },
        isAdvanced:{
            type: Boolean,
            required: false,
        }
    },

    data () {
        return {
            deleteLoading: false
        };
    },

    computed:{
        ...mapGetters(['downloadFile']),
        failedSimulation(){
            return this.motor.simulation_status === 'FAILED';
        },
        disabledXlsxButton(){
            if(this.failedSimulation || this.pendingSimulationStatus){
                return true;
            }
            return false;
        },
        disabledPptxButton(){
            if(this.failedSimulation || this.pendingSimulationStatus){
                return true;
            }
            return false;
        },
        loadingXlsxButton(){
            if(this.completedSimulationStatus){
                if(this.motor.xlsx_status === 'PENDING' || this.motor.xlsx_status === 'RUNNING'){
                    return true;
                }
            }
            return false;
        },
        loadingPptxButton(){
            if(this.completedSimulationStatus){
                if(this.motor.pptx_status === 'PENDING' || this.motor.pptx_status === 'RUNNING'){
                    return true;
                }
            }
            return false;
        },
        completedSimulationStatus(){
            return this.motor.simulation_status === 'COMPLETED';
        },
        pendingSimulationStatus(){
            return this.motor.simulation_status === 'PENDING' || this.motor.simulation_status === 'RUNNING';
        }
    },

    methods:{
        deleteMotor(){
            this.$confirm('Voulez-vous supprimer ce moteur ?', this.motor.name, {
                confirmButtonText: 'Supprimer',
                cancelButtonText: 'Annuler',
                type: 'warning'
            })
            .then(() =>{
                this.deleteLoading = true;
                this.$store.dispatch('patchItem', {
                    item: {
                        uid: this.motor.uid,
                        url: this.motor.url,
                        archived: true
                    },
                    model: 'motors',
                }).then(() => {
                    this.deleteLoading = false;
                    this.$notify.success({
                        title: this.motor.name,
                        message: 'Moteur supprimé'
                    });
                    this.$emit('refresh-data');
                }).catch((e) => {
                    this.deleteLoading = false;
                    console.error(e);
                });
            });
        },
        loadMeasurements(){
            this.$emit('open-simulation-modal', this.motor);
        },
        downloadXlsx(){
            if(this.motor.xlsx_status && this.motor.xlsx_status === 'FAILED'){
                let verboseStatus = this.motor.xlsx_verbose_status ? this.motor.xlsx_verbose_status : '';
                this.$alert(verboseStatus, 'Erreur', {
                    confirmButtonText: 'Ok',
                    type: 'warning'
                });
            } else {
                if(this.motor.xlsx_file){
                    let urlParts = this.motor.xlsx_file.split('/');
                    let fileName = urlParts.pop();
                    this.$store.dispatch('downloadFile', {
                        fileUrl: `${this.motor.xlsx_file}?nocache=${Date.now()}`,
                        fileName: fileName
                    });
                }
            }
        },
        downloadPptx(){
            if(this.motor.pptx_status && this.motor.pptx_status === 'FAILED'){
                let verboseStatus = this.motor.pptx_verbose_status ? this.motor.pptx_verbose_status : '';
                this.$alert(verboseStatus, 'Erreur', {
                    confirmButtonText: 'Ok',
                    type: 'warning'
                });
            } else {
                if(this.motor.pptx_file){
                    let urlParts = this.motor.pptx_file.split('/');
                    let fileName = urlParts.pop();
                    this.$store.dispatch('downloadFile', {
                        fileUrl: `${this.motor.pptx_file}?nocache=${Date.now()}`,
                        fileName: fileName
                    });
                }
            }
        },
        editMotor(){
            this.$router.push({
                name: 'AdvancedMotorForm',
                params: {
                    motorUid: this.motor.uid
                }
            });
        },
        goToMotorDetails(){
            if(this.completedSimulationStatus){
                this.$router.push({
                    name: 'SimulationDetails',
                    params: {
                        motorUid: this.motor.uid,
                        mode: this.motor.mode
                    }
                });
            } else if (this.motor.simulation_status === 'PENDING') {
                this.$alert('Aucune mesure pour ce moteur', 'Erreur', {
                    confirmButtonText: 'Ok',
                    type: 'warning'
                });
            } else if (this.motor.simulation_status === 'RUNNING') {
                this.$alert('Mesure en cours de calcul', 'En cours', {
                    confirmButtonText: 'Ok',
                    type: 'warning'
                });
            } else {
                this.$alert(this.motor.verbose_status, 'Erreur', {
                    confirmButtonText: 'Ok',
                    type: 'warning'
                });
            }
        },
    }
};
</script>

<style lang="scss">
.home-tile{
    background-color: #005BBA;
}
.avanced{
    background-color: #455769;
}
.title-container{
    display: flex;
    justify-content: space-between;
}
.element-icon {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 4rem;
    height: 4rem;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.5);
    i{
        margin: 0;
    }
}
.element-icon:hover {
    background-color: #001B6F;
    border: #001B6F;
    cursor: pointer;
}
.buttons-motor-container{
    margin-top: 2rem;
    position: relative;
    z-index: 2;
    display: flex;
    gap: 1.5rem;
    .el-button{
        background: rgba(255, 255, 255, 0.3);
        border: rgba(0,0,0,0.5);
        border-radius: 3em;
        color: white;

    }
    .el-button:hover{
        background-color: #001B6F;
        border: #001B6F;
    }
    .el-button.is-disabled{
        background: #999999;
    }
}
.action-buttons-container{
    display: flex;
    gap: 1rem;
}
.tile-icon-image {
    img{
        position: absolute;
        left: 20px;
        top: 25%;
        transform: translate(0, -50%);
        font-size: 20px;
        height: 30px;
    }
}
.tile-icon-image-bg {
    transform: translate(10%, 10%);
    height: 2px;
    opacity: .2;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Home/motors/MotorCard.vue